
<button
  type="button"
  role="button"
  class="portal-card"
  :class="{
    'portal-card--disabled': disabled,
    'portal-card--loading': loading
  }"
  :aria-label="title"
  :aria-disabled="disabled"
  :disabled="disabled"
  @click="handleClick"
  @keydown.enter.prevent="handleClick"
  @keydown.space.prevent="handleClick"
>
  <div class="portal-card__icon-container">
    <div v-if="loading" class="portal-card__spinner" role="status" aria-label="Loading">
      <LucideIcon name="Loader2" :size="48" />
    </div>
    <LucideIcon v-else :name="icon" :size="48" />
  </div>
  <h3 class="portal-card__title">{{ title }}</h3>
  <p v-if="description" class="portal-card__description">{{ description }}</p>
</button>
